import { Component, HostListener, OnInit, OnDestroy } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { DssCardModule } from '@dss/components';

import { OfertasService } from '../services/ofertas/ofertas.service';
import { Dados } from '../model/dados.model';
import { SafeCurrencyPipe } from '../pipes/safe-currency.pipe';

import { Observable, Subscription, timer } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import moment from 'moment';

const POLLING_INTERVAL_MS = 10000;

@Component({
  standalone: true,
  selector: 'app-card-cbio',
  templateUrl: './card-cbio.component.html',
  styleUrls: ['./card-cbio.component.scss'],
  imports: [CommonModule, TranslateModule, DssCardModule, SafeCurrencyPipe],
  providers: [CurrencyPipe]
})
export class CardCbioComponent implements OnInit, OnDestroy {
  public dadosAsc$: Observable<Dados>;
  private pollingSub: Subscription;
  constructor(private ofertasService: OfertasService) {

  }

  public ngOnInit(): void {
    this.dadosAsc$ = this.ofertasService.state$.pipe(
      map(state => state.resultado)
    );
    this.pollingSub = timer(0, POLLING_INTERVAL_MS).subscribe(() => {
      this.ofertasService.getData();
    });
  }
  public moment = moment;

  public ngOnDestroy(): void {
    this.pollingSub?.unsubscribe();
  }



}
